/**
 * Утилиты для безопасной работы со строками, содержащими эмодзи.
 *
 * Проблема: В JavaScript эмодзи представлены как
 * surrogate pairs — два 16-битных code units. Например:
 * - "😀".length === 2 (а не 1)
 * - "😀"[0] === "\uD83D" (high surrogate)
 * - "😀"[1] === "\uDE00" (low surrogate)
 *
 * Если разрезать строку посередине surrogate pair, получится битый текст.
 */

/**
 * Проверяет, является ли символ high surrogate
 */
export const isHighSurrogate = (charCode: number): boolean => {
    return charCode >= 0xd800 && charCode <= 0xdbff
}

/**
 * Проверяет, является ли символ low surrogate
 */
export const isLowSurrogate = (charCode: number): boolean => {
    return charCode >= 0xdc00 && charCode <= 0xdfff
}

/**
 * Корректирует позицию, чтобы она не попадала внутрь эмоджи.
 */
export const getPositionForSurrogatePairs = (str: string, position: number): number => {
    if (position <= 0) return 0
    if (position >= str.length) return str.length

    const charCode = str.charCodeAt(position)

    if (isLowSurrogate(charCode)) {
        return position - 1
    }

    return position
}

/**
 * Безопасно разделяет строку на две части по позиции курсора.
 */
export const safeSplitAtPosition = (str: string, position: number): [string, string] => {
    if (!str) return ["", ""]

    const safePosition = getPositionForSurrogatePairs(str, position)

    return [str.substring(0, safePosition), str.substring(safePosition)]
}
